import { render, staticRenderFns } from "./PlatformRules.vue?vue&type=template&id=f2cc265a&scoped=true&"
var script = {}
import style0 from "./PlatformRules.vue?vue&type=style&index=0&id=f2cc265a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f2cc265a",
  null
  
)

export default component.exports